
export type Tomo = {
  n: string
  title: string
  desc: string
  cover: string
  coverAlt: string
  /** Per-volume accent, so the six read as a collection with personality. */
  accent: string
  accentBg: string
}

/**
 * `cover` holds the editorial cover artwork for each volume.
 * These represent the volumes — never interior page scans.
 * Real interior pages live only in components/ContentPreview.tsx.
 */
export const TOMOS: Tomo[] = [
  {
    n: '01',
    title: 'Hoja de Ruta de Evaluación',
    desc: 'Estructura la evaluación desde el primer contacto.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6693c0d6-5616-4da3-afdd-ef9b0e978819.jpg',
    coverAlt: 'Portada del Tomo 1 — Hoja de Ruta de Evaluación',
    accent: 'text-steel',
    accentBg: 'bg-steel/12 border-steel/30',
  },
  {
    n: '02',
    title: 'Criterio en Miembro Superior',
    desc: 'Hombro, codo y mano con criterio clínico.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/46cabc1c-d01e-41cb-babc-90e108b20463.jpg',
    coverAlt: 'Portada del Tomo 2 — Criterio en Miembro Superior',
    accent: 'text-clinic-dark',
    accentBg: 'bg-clinic/12 border-clinic/30',
  },
  {
    n: '03',
    title: 'Diagnóstico en Columna y Raquis',
    desc: 'Evaluación cervical, dorsal y lumbar.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/44ce578c-5f4d-4d07-ac2e-74d7cd5fcd33.jpg',
    coverAlt: 'Portada del Tomo 3 — Diagnóstico en Columna y Raquis',
    accent: 'text-indigoSoft',
    accentBg: 'bg-indigoSoft/12 border-indigoSoft/30',
  },
  {
    n: '04',
    title: 'Mecánica de Miembro Inferior',
    desc: 'De la cadera al pie con lógica biomecánica.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/dd0419e0-d19e-4f4d-b338-d519cb146b16.jpg',
    coverAlt: 'Portada del Tomo 4 — Mecánica de Miembro Inferior',
    accent: 'text-copper',
    accentBg: 'bg-copper/12 border-copper/30',
  },
  {
    n: '05',
    title: 'Diccionario Maestro de Pruebas',
    desc: 'Qué evalúa cada prueba y cómo interpretarla.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/80d67f6b-b751-4df6-a87a-2a31ae5854e4.jpg',
    coverAlt: 'Portada del Tomo 5 — Diccionario Maestro de Pruebas',
    accent: 'text-sage',
    accentBg: 'bg-sage/12 border-sage/30',
  },
  {
    n: '06',
    title: 'Casos Clínicos Reales',
    desc: 'Razonamiento aplicado a casos reales.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/85da2591-8b4a-4591-8ad5-d0384702c482.jpg',
    coverAlt: 'Portada del Tomo 6 — Casos Clínicos Reales',
    accent: 'text-gold-deep',
    accentBg: 'bg-gold/12 border-gold/35',
  },
]
